import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import API,{base} from "../api.js";
import { Link} from 'react-router-dom';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
class Refund extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            homePage:false,
            list:[]
        }
    }

    componentDidMount() {
      ReactGA.initialize('UA-157984080-1');
      ReactGA.pageview(window.location.pathname + window.location.search);
      
      ReactPixel.init('197333187452630');
      // ReactPixel.pageView();
        API({
              method: 'GET',
              url: "display/video",
              data:'json',
            }).then(data => {
              this.setState({list:data.data.response.data});
            }).catch(()=>{
                this.setState({lockSubmit:false});
            });
    }
 render(){   
    return (
    <React.Fragment>
    <Header />   
      <div className="hero-section mt-80">
        <div className="container">
            <div className="row align-items-center">
            <div className="col-lg-8 col-md-8">
              <div className="hero-content">
                  <h1 className="primary-heading mfw-600">
                    Wall of Fame            
                  </h1>
                  <p className="sub-heading bold-sub-heading">
                  Meet our champions who have made it <br className='d-none d-md-block' /> in the PTE / NAATI CCL exam
                  </p>
                  <div className="text-center text-md-start">
                  <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                  </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="hero-img-wrapper">
                  <img
                  className="img-fluid"
                  src="/images/web-new-images/bannerImg.png"
                  alt="LA"
                  />
              </div>
            </div>
            </div>
        </div>
      </div>    
      <section className="fameWall">
          <div className="container">           
            <div className="row">
              <div className="col-6 col-md-4 col-lg-3">
                <div className='fameCard'>
                   <img src="images/web-new-images/pte/pte1.jpeg" alt="fame-img-01" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">  
                <div className='fameCard'>
                  <img src="images/web-new-images/pte/pte2.jpeg" alt="fame-img-02" />               
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
                <div className='fameCard'>
                  <img src="images/web-new-images/pte/pte3.jpeg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
                <div className='fameCard'>
                  <img src="images/web-new-images/pte/pte4.jpeg" alt="fame-img-04" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
                <div className='fameCard'>
                  <img src="images/web-new-images/pte/pte5.jpeg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte6.jpeg" alt="fame-img-01" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte7.jpeg" alt="fame-img-02" />
              </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte8.jpeg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte9.jpeg" alt="fame-img-04" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte10.jpeg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte11.jpeg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/pte/pte12.jpeg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/punjabi3.jpg" alt="fame-img-01" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/urdu1.jpg" alt="fame-img-02" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi3.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi1.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
                <div className='fameCard'>
                  <img src="images/web-new-images/naati/hindi4.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
                  <div className='fameCard'>
                    <img src="images/web-new-images/naati/hindi5.jpg" alt="fame-img-03" />
                  </div>
                </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi6.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi7.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi8.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi9.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi10.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi11.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali4.jpg" alt="fame-img-04" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/bangla1.jpg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali6.jpg" alt="fame-img-01" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/urdu2.jpg" alt="fame-img-02" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/urdu3.jpg" alt="fame-img-03" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/hindi2.jpg" alt="fame-img-04" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali2.jpg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali3.jpg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali4.jpg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali5.jpg" alt="fame-img-05" />
                </div>
              </div>
              <div className="col-6 col-md-4 col-lg-3">
              <div className='fameCard'>
                <img src="images/web-new-images/naati/nepali6.jpg" alt="fame-img-05" />
                </div>
              </div>
            </div>               
            </div>
      </section>
    <Footer />
  </React.Fragment>);
  }
}

export default Refund;